const {
    BROKER_CONVENIENCE_MIFID_TEST_STEP0_CHANGE_UPDATE_REASON
} = require('mifid/constants/actionTypes.js');

const changeUpdateReason = (updateReason) => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP0_CHANGE_UPDATE_REASON,
        payload: {
            updateReason: updateReason
        }
    });
}

module.exports = {
    changeUpdateReason
}